/* eslint-disable import/prefer-default-export */

export const ladderSides = {
  L: {
    label: 'Left',
  },
  R: {
    label: 'Right',
  },
};
